import { Component } from "preact";
import '../style/start-form.css';
import { ConfigContext } from '../contexts/config';
import OutsideLink from "./outside-link";

export default class StartForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: null,
            mail: null,
            consent: false
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        this.props.onSubmit({
            name: this.state.name,
            mail: this.state.mail
        })
    }

    renderConsent(config) {
        const label = config.getTranslations().startFormConsentLabel;
        const link  = config.startFormConsentLink;
        let labelElement = <label htmlFor={'consent'}>{label}</label>;

        const labelParts = label.split('{link}', 3);

        if (link !== null && labelParts.length === 3) {
            labelElement = <label htmlFor={'consent'}>
                {labelParts[0]}
                <OutsideLink href={link} content={labelParts[1]}/>
                {labelParts[2]}
            </label>;
        }

        return (
            <div className={'form-item for-consent'}>
                <input
                    disabled={this.props.disableAll}
                    required
                    type={'checkbox'}
                    name={'consent'}
                    id={'consent'}
                    checked={this.state.consent}
                    onChange={(e) => this.setState({consent: !this.state.consent})}
                />
                {labelElement}
            </div>
        );
    }

    render() {
        return (
            <ConfigContext.Consumer>
                {config => (
                    <form className={'start-form'}>
                        <div className={'form-item for-name'}>
                            <label htmlFor={'name'}>{config.getTranslations().startFormNameLabel}:</label>
                            <input
                                disabled={this.props.disableAll}
                                required
                                type={'text'}
                                name={'name'}
                                id={'name'}
                                placeholder={config.getTranslations().startFormNameLabel}
                                onInput={(e) => this.setState({name: e.target.value})}
                            />
                        </div>
                        {config.startFormRequireMail &&
                            <div className={'form-item for-mail'}>
                                <label htmlFor={'mail'}>{config.getTranslations().startFormMailLabel}</label>
                                <input
                                    disabled={this.props.disableAll}
                                    required
                                    type={'text'}
                                    name={'mail'}
                                    id={'mail'}
                                    placeholder={config.getTranslations().startFormMailLabel}
                                    onInput={(e) => this.setState({mail: e.target.value})}
                                />
                            </div>
                        }
                        {config.startFormRequireConsent &&
                            this.renderConsent(config)
                        }
                        <button
                            onClick={this.handleSubmit.bind(this)}
                            disabled={
                                this.props.disableAll || !(
                                    this.state.name &&
                                    (config.startFormRequireMail ? this.state.mail : true) &&
                                    (config.startFormRequireConsent ? this.state.consent : true )
                                )
                            }
                        >{config.getTranslations().startFormEnterButton}</button>
                    </form>
                )}
            </ConfigContext.Consumer>
        )
    }
}